import {Observable, of} from 'rxjs';
import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {catchError, filter, switchMapTo, take, tap} from 'rxjs/operators';
import {LoadNotifications} from '@automata/actions/notifications.actions';

@Injectable()
export class NotificationsGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) {
  }

  public canActivate(): Observable<boolean> {
    return this.checkNotifications()
      .pipe(
        switchMapTo(of(true)),
        catchError(() => of(false))
      );
  }

  checkNotifications(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectNotificationsLoaded),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(LoadNotifications());
        }
      }),
      filter(isLoaded => isLoaded),
      take(1)
    );
  }
}
